
var guidUtil = require('../../guid/guidUtil');
var storefrontUtility = require('../storefrontUtility');
var commonUtility = require('../commonUtility');
var terminalUtility = require('../terminalUtility');
var staffUtility = require('../staff/staffUtility');
var cashFloatUtil = require('../cashFloatUtil');
var orderNumberFountain = require('../orderNumberFountain');
var validator = require('../../validator/validator.js');
var localizationUtils = require('../../domain/localizationUtils.js');
var dateUtil = require('../../dateUtil/dateUtil');
var formatter = require('../../formatter/formatter');
var constants = require('../constants');

module.exports.createNewSale = function(venueCode, dispatchType, storefrontId)
{
    var sale = {};

    if (storefrontId == null)
        storefrontId = storefrontUtility.getCurrentStorefront().id;

    sale.id = guidUtil.generateGuid();
    sale.storefrontId = storefrontId;
    sale.propertyId = commonUtility.getProperty().id;
    sale.terminalId = terminalUtility.getTerminalId();
    sale.floatSessionId = cashFloatUtil.getActiveFloatSessionId();
    sale.venueCode = venueCode;
    sale.dispatchType = dispatchType;
    sale.dateTime = null;
    sale.originalPlannedDispatchDateTime = null;
    sale.currentPlannedDispatchDateTime = null;
    sale.actualDispatchDateTime = null;
    sale.number = orderNumberFountain.getNextOrderNumber().toString();
    sale.tableNumber = null;
    sale.linkedTables = [];
    sale.operator = staffUtility.getLoginStaffCompleteName();
    sale.server = null;
    sale.saleType = constants.SaleTypeSale;
    sale.paidAmount = 0.0;
    sale.rewardPoints = 0.0;
    sale.paymentMethod = constants.PaymentMethodNA;
    sale.channel = constants.channels.POS;
    sale.isCancelled = false;
    sale.cancellationReason = null;
    sale.instructions = null;
    sale.tag = null;
    sale.saleItems = [];
    sale.charges = [];
    sale.discounts = [];
    sale.refunds = [];
    sale.receiptLines = [];
    sale.status = [];
    sale.endorsements = [];     // saleEndorsement integration items

    return sale;
}

module.exports.createReceiptLine = function(type, amount, mode)
{
    var receiptLine = {};
    receiptLine.type = type;
    receiptLine.dateTime = dateUtil.getNow();
    receiptLine.amount = amount;
    receiptLine.paymentMethod = mode;
    receiptLine.terminalId = terminalUtility.getTerminalId();
    receiptLine.floatSessionId = cashFloatUtil.getActiveFloatSessionId();
    var line = {};
    line.dateTime = receiptLine.dateTime;
    line.mode = mode;
    line.amount = amount;
    receiptLine.line = JSON.stringify(line);

    return receiptLine;
}

module.exports.createSaleItem = function(category, quantity, caption, unitPrice, vat)
{
    var saleItem = {};
    
    saleItem.id = guidUtil.generateGuid();
    
    saleItem.caption = caption;
    saleItem.productId = null
    saleItem.category = category
    saleItem.quantity = quantity;
    saleItem.isPaid = false;
    saleItem.isRefunded = false;
    saleItem.refundCode = null;
    saleItem.unitUpsellingPoints = null;
    saleItem.paramsJson = null;
    saleItem.backgroundColor = null
    saleItem.foregroundColor = null
    saleItem.saleItems = [];

    saleItem.unitPrice = unitPrice;
    saleItem.vat = vat;
    
    return saleItem;
}

module.exports.calculateUnitTax = function(taxablePrice, tax)
{
    if (!validator.isNumeric(taxablePrice) || 
        !validator.isNumeric(tax))
        return 0.0;

    if (localizationUtils.isVatInclusive())
        return formatter.roundUp(taxablePrice - (taxablePrice / (1+tax)), 2);
    else
        return formatter.roundUp(taxablePrice * tax, 2);
}
